<template>
    <div style="margin-top:50px;">
        <div class="listItem" @click="LookInfo">
            <el-image :src="Item['Cover'] || url" lazy class="leftImg"></el-image>
            <div class="rightBox">
                <div class="rightTitle">{{Item['Title']}}</div>
                <div class="rightInfo" v-html="Item['Describe']"></div>
                <div class="rightBtnBox">
                    <el-button @click="ApplyUse(Item.ID)" size="mini" type="primary">申请试用</el-button>
                    <el-button @click="toGo(Item.Url)" size="mini" type="warning">访问系统</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        Item:{
            type:Object,
        }
    },
    data(){
        return{
            url:'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
        }
    },
    methods:{
         LookInfo(){
            this.$emit('LookInfo',this.Item.ID)
        },
        ApplyUse(){
           this.$emit('ApplyStatus',true)
        },
        toGo(n){
            window.open(n);
        },
    },
}
</script>
<style lang="scss" scoped>
    .listItem{
        display: inline-flex;
        width: 100%;
        margin-bottom: 30px;
        .leftImg{
            height: 200px;
            width: 400px;
        }
        .rightBox{
            margin-left: 20px;
            text-align: left;
             width: 100%;
            .rightTitle{
                font-size: 15px;
                font-weight: 400;
                line-height: 30px;
            }
            .rightInfo{
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                text-indent: 28px;
                height: 130px;
                line-height:22px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 6;
                -webkit-box-orient: vertical;
            }
            .rightBtnBox{
                line-height: 40px;
            }
        }
    }
</style>